import { render, staticRenderFns } from "./NFT.vue?vue&type=template&id=5b72839c&scoped=true&"
import script from "./NFT.vue?vue&type=script&lang=js&"
export * from "./NFT.vue?vue&type=script&lang=js&"
import style0 from "./NFT.vue?vue&type=style&index=0&id=5b72839c&prod&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "5b72839c",
  null
  
)

export default component.exports